export default __webpack_public_path__ + "static/media/glutarain.0fe37345.jpg";